export const analytics = {
  "loginBtn": {
    "ID": "LoginBtn",
    "portal_screen_name": "Login",
    "portal_section": "LoginWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Login",
    "Portal_event_description": "Login button is clicked on login screen"
  },
  "ContinueAsGuestBtn": {
    "ID": "ContinueAsGuestBtn",
    "portal_screen_name": "Login",
    "portal_section": "LoginWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "ContinueAsGuest",
    "Portal_event_description": "Continue As Guest button is clicked on login screen"
  },
  "ForgotPassword": {
    "ID": "ForgotPassword",
    "portal_screen_name": "Login",
    "portal_section": "LoginWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "ForgotPassword",
    "Portal_event_description": "Forgot Password is clicked on login screen"
  },
  "ForgotPasswordPopupYesBtn": {
    "ID": "ForgotPasswordPopupYesBtn",
    "portal_screen_name": "ForgotPasswordPopup",
    "portal_section": "ForgotPasswordPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Yes",
    "Portal_event_description": "Yes button is clicked on forgot password popup"
  },
  "ForgotPasswordPopupCloseBtn": {
    "ID": "ForgotPasswordPopupCloseBtn",
    "portal_screen_name": "ForgotPasswordPolicyPopup",
    "portal_section": "ForgotPasswordPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "closeBtn",
    "Portal_event_description": "Close button is clicked on forgot password popup"
  },
  "GetHelp": {
    "ID": "GetHelp",
    "portal_screen_name": "Login",
    "portal_section": "LoginWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "GetHelp",
    "Portal_event_description": "Get Help button is clicked on login screen"
  },
  "PrivacyPolicy": {
    "ID": "PrivacyPolicy",
    "portal_screen_name": "Login",
    "portal_section": "LoginWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "PrivacyPolicy",
    "Portal_event_description": "Privacy Policy button is clicked on login screen"
  },
  "PrivacyPolicyYesBtn": {
    "ID": "PrivacyPolicyPopupYesBtn",
    "portal_screen_name": "PrivacyPolicyPopup",
    "portal_section": "PrivacyPolicyPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Yes",
    "Portal_event_description": "Yes button is clicked on privacy policy popup"
  },
  "PrivacyPolicyPopupCloseBtn": {
    "ID": "PrivacyPolicyPopupCloseBtn",
    "portal_screen_name": "PrivacyPolicyPopup",
    "portal_section": "PrivacyPolicyPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "closeBtn",
    "Portal_event_description": "Close button is clicked on privacy policy popup"
  },
  "SignUp": {
    "ID": "SignUp",
    "portal_screen_name": "Login",
    "portal_section": "SignupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "SignUp",
    "Portal_event_description": "Signup button is clicked on login screen"
  },
  "Proceed": {
    "ID": "Proceed",
    "portal_screen_name": "Login",
    "portal_section": "SignupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Proceed",
    "Portal_event_description": "Procedd button is clicked on login screen"
  },
  "WVLogoBtn": {
    "ID": "WVLogoBtn",
    "portal_screen_name": "Login",
    "portal_section": "LoginWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "WVLogo",
    "Portal_event_description": "WV Logo is clicked on login screen"
  },
  "WVLogoPopupYesBtn": {
    "ID": "WVLogoPopupYesBtn",
    "portal_screen_name": "WVLogoPopup",
    "portal_section": "WVLogoPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Yes",
    "Portal_event_description": "Yes button is clicked on WV Logo popup in login screen"
  },
  "www.worldvision.org.nz": {
    "ID": "www.worldvision.org.nz",
    "portal_screen_name": "WVLogoPopup",
    "portal_section": "WVLogoPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": " www.worldvision.org.nz",
    "Portal_event_description": "URL is clicked on WV Logo popup in login screen"
  },
  "WVLogoPopupCloseBtn": {
    "ID": "WVLogoPopupCloseBtn",
    "portal_screen_name": "WVLogoPopup",
    "portal_section": "WVLogoPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "closeBtn",
    "Portal_event_description": "Close button is clicked on WV Logo popup in login screen"
  },
  "IUnderstandBtn": {
    "ID": "IUnderstandBtn",
    "portal_screen_name": "AfterLoginConfirmationPopup",
    "portal_section": "ModalPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Iunderstand",
    "Portal_event_description": "I Understand button is clicked on after login confirmation popup"
  },
  "PrivacyPolicy_AfterLogin": {
    "ID": "PrivacyPolicy_AfterLogin",
    "portal_screen_name": "AfterLoginConfirmationPopup",
    "portal_section": "ModalPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "PrivacyPolicy",
    "Portal_event_description": "Privacy Policy button is clicked on after login confirmation popup"
  },
  "PrivacyPolicy_AfterLoginCloseBtn": {
    "ID": "PrivacyPolicy_AfterLoginCloseBtn",
    "portal_screen_name": "AfterLoginConfirmationPopup",
    "portal_section": "ModalPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "closeBtn",
    "Portal_event_description": "Close button is clicked on after login confirmation popup"
  },
  "CookieSettingsSubmit": {
    "ID": "CookieSettingsSubmit",
    "portal_screen_name": "AfterLoginConfirmationPopup",
    "portal_section": "ModalPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "SaveSettings",
    "Portal_event_description": "Save Settings button is clicked on after login confirmation popup"
  },

  "SignleChildName": {
    "ID": "SignleChildName",
    "portal_screen_name": "WorldScreen",
    "portal_section": "WorldScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "ChildName",
    "Portal_event_description": "Child is clicked on world map screen"
  },
  "GroupChildName": {
    "ID": "GroupChildName",
    "portal_screen_name": "WorldScreen",
    "portal_section": "WorldScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "ChildName",
    "Portal_event_description": "Child is clicked on world map screen"
  },
  "SelectedChildInPopup": {
    "ID": "SelectedChildInPopup",
    "portal_screen_name": "WorldScreen",
    "portal_section": "WorldScreenPopup",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "ChildName",
    "Portal_event_description": "Child is clicked on world screen popup"
  },
  "MeBtn": {
    "ID": "MeBtn",
    "portal_screen_name": "WorldScreen",
    "portal_section": "WorldScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "SONameBtn",
    "Portal_event_description": "Me button is clicked on world map screen"
  },
  "WorldScreenCloseBtn": {
    "ID": "WorldScreenCloseBtn",
    "portal_screen_name": "WorldScreen",
    "portal_section": "WorldScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "WorldScreenCloseBtn",
    "Portal_event_description": "Close button is clicked on world map screen"
  },
  "WVLogoBtn_WorldScreen": {
    "ID": "WVLogoBtn_WorldScreen",
    "portal_screen_name": "WorldScreen",
    "portal_section": "WorldScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "WVLogo",
    "Portal_event_description": "WV Logo button is clicked on world map screen"
  },

  "LetsExploreButton": {
    "ID": "LetsExploreButton",
    "portal_screen_name": "HomeScreen- WelcomePopup",
    "portal_section": "ModalPopup Widget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Let's Explore",
    "Portal_event_description": "Let's Explore button is clicked on home screen - welcome popup"
  },
  "NotRightNow": {
    "ID": "NotRightNow",
    "portal_screen_name": "HomeScreen- WelcomePopup",
    "portal_section": "ModalPopup Widget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "NotRightNow",
    "Portal_event_description": "Not Right Now button is clicked on home screen - welcome popup"
  },
  "WelcomeBtnLabel1": {
    "ID": "WelcomeBtnLabel1",
    "portal_screen_name": "HomeScreen- WelcomePopup",
    "portal_section": "ModalPopup Widget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Okay I Ready",
    "Portal_event_description": "Okay I Ready button is clicked on home screen - welcome popup"
  },
  "WelcomePopupCloseBtn": {
    "ID": "WelcomePopupCloseBtn",
    "portal_screen_name": "HomeScreen- WelcomePopup",
    "portal_section": "ModalPopup Widget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "WelcomePopupCloseBtn",
    "Portal_event_description": "Close button is clicked on home screen - welcome popup"
  },
  "ChildStation": {
    "ID": "ChildStation",
    "portal_screen_name": "HomeScreen",
    "portal_section": "HomeScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "ChildStation",
    "Portal_event_description": "Child Station is clicked on home screen"
  },
  "CommunityStation": {
    "ID": "CommunityStation",
    "portal_screen_name": "HomeScreen",
    "portal_section": "HomeScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "CommunityStation",
    "Portal_event_description": "Community Station is clicked on home screen"
  },
  "EducationStation": {
    "ID": "EducationStation",
    "portal_screen_name": "HomeScreen",
    "portal_section": "HomeScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "EducationStation",
    "Portal_event_description": "Education Station is clicked on home screen"
  },
  "HealthNutritionStation": {
    "ID": "HealthNutritionStation",
    "portal_screen_name": "HomeScreen",
    "portal_section": "HomeScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "HealthNutritionStation",
    "Portal_event_description": "Health Nutrition Station is clicked on home screen"
  },
  "WaterStation": {
    "ID": "WaterStation",
    "portal_screen_name": "HomeScreen",
    "portal_section": "HomeScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "WaterLivelihoodsStation",
    "Portal_event_description": "Water Station is clicked on home screen"
  },
  "PersonalDevelopmentStation": {
    "ID": "PersonalDevelopmentStation",
    "portal_screen_name": "HomeScreen",
    "portal_section": "HomeScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "PersonalDevelopmentStation",
    "Portal_event_description": "Personal Development Station is clicked on home screen"
  },
  "WVLogoBtn_HomeScreen": {
    "ID": "WVLogoBtn_HomeScreen",
    "portal_screen_name": "HomeScreen",
    "portal_section": "HomeScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "WVLogo",
    "Portal_event_description": "WV Logo button is clicked on home screen"
  },
  "SwitchChild": {
    "ID": "SwitchChild",
    "portal_screen_name": "HomeScreen",
    "portal_section": "HomeScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "SwitchChild",
    "Portal_event_description": "Switch Child is clicked on home screen"
  },
  "HomeBtn": {
    "ID": "HomeBtn",
    "portal_screen_name": "HomeScreen",
    "portal_section": "HomeScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Home",
    "Portal_event_description": "Home menu is clicked on home screen"
  },
  "ConnectBtn": {
    "ID": "ConnectBtn",
    "portal_screen_name": "HomeScreen",
    "portal_section": "HomeScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Connect",
    "Portal_event_description": "Connect menu is clicked on home screen"
  },
  "GiveBtn": {
    "ID": "GiveBtn",
    "portal_screen_name": "HomeScreen",
    "portal_section": "HomeScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Give",
    "Portal_event_description": "Give menu is clicked on home screen"
  },
  "GetHelpBtn": {
    "ID": "GetHelpBtn",
    "portal_screen_name": "HomeScreen",
    "portal_section": "HomeScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "GetHelp",
    "Portal_event_description": "Get Help menu is clicked on home screen"
  },
  "Stories": {
    "ID": "Stories",
    "portal_screen_name": "HomeScreen",
    "portal_section": "HomeScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Stories",
    "Portal_event_description": "Stories menu is clicked on home screen"
  },
  "MoreBtn": {
    "ID": "MoreBtn",
    "portal_screen_name": "HomeScreen",
    "portal_section": "HomeScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "More",
    "Portal_event_description": "More menu is clicked on home screen"
  },

  "BackBtn": {
    "ID": "BackBtn",
    "portal_screen_name": "ChildStationDetailScreen",
    "portal_section": "ChildStationDetailWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Back",
    "Portal_event_description": "Back button is clicked on home screen"
  },
  "AboutMe": {
    "ID": "AboutMe",
    "portal_screen_name": "ChildStationDetailScreen",
    "portal_section": "ChildStationDetailWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "AboutMe",
    "Portal_event_description": "About Me tab is clicked on child station detail screen"
  },
  "HowI'VeGrown": {
    "ID": "HowI'VeGrown",
    "portal_screen_name": "ChildStationDetailScreen",
    "portal_section": "ChildStationDetailWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "How I've Grown",
    "Portal_event_description": "How I've Grown tab is clicked on child station detail screen"
  },
  "SendBirthdayGreetings": {
    "ID": "SendBirthdayGreetings",
    "portal_screen_name": "ChildStationDetailScreen",
    "portal_section": "ChildStationBirthdayPopup",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Send Birthday Greetings",
    "Portal_event_description": "Send Birthday Greetings button is clicked on child station birthday popup"
  },
  "NotRightNow_ChildStation": {
    "ID": "NotRightNow_ChildStation",
    "portal_screen_name": "ChildStationDetailScreen",
    "portal_section": "ChildStationBirthdayPopup",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Not right now",
    "Portal_event_description": "Not Right Now button is clicked on child station birthday popup"
  },
  "BirthdayPopupCloseBtn": {
    "ID": "BirthdayPopupCloseBtn",
    "portal_screen_name": "ChildStationDetailScreen",
    "portal_section": "ChildStationBirthdayPopup",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "BirthdayPopupCloseBtn",
    "Portal_event_description": "Close button is clicked on child station birthday popup"
  },

  "AboutCommunity": {
    "ID": "AboutCommunity",
    "portal_screen_name": "CommunityStationDetailScreen",
    "portal_section": "CommunityStationDetailWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "AboutCommunity",
    "Portal_event_description": "About Community Station is clicked on home screen"
  },
  "AboutCountry": {
    "ID": "AboutCountry",
    "portal_screen_name": "CommunityStationDetailScreen",
    "portal_section": "CommunityStationDetailWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "AboutCountry",
    "Portal_event_description": "About Country tab is clicked on  community station detail screen"
  },
  "LifeAndCulture": {
    "ID": "LifeAndCulture",
    "portal_screen_name": "CommunityStationDetailScreen",
    "portal_section": "CommunityStationDetailWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Life and culture",
    "Portal_event_description": "Life and Culture tab is clicked on community station detail screen"
  },
  "LearnMore": {
    "ID": "LearnMore",
    "portal_screen_name": "CommunityStationDetailScreen",
    "portal_section": "CommunityStationDetailWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "LearnMore",
    "Portal_event_description": "Learn More button is clicked on community station detail screen"
  },
  "ShowLess": {
    "ID": "ShowLess",
    "portal_screen_name": "CommunityStationDetailScreen",
    "portal_section": "CommunityStationDetailWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "ShowLess",
    "Portal_event_description": "Show Less button is clicked on community station detail screen"
  },

  "BackBtn_stationDetail": {
    "ID": "BackBtn_stationDetail",
    "portal_screen_name": "StationDetailScreen",
    "portal_section": "StationDetailWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Back",
    "Portal_event_description": "Back button is clicked on stations detail screen"
  },
  "FeedItemsClick": {
    "ID": "FeedItemsClick",
    "portal_screen_name": "StationDetailScreen",
    "portal_section": "StationDetailWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "FeedItemsPopup",
    "Portal_event_description": "Feed Items is clicked on stations detail screen"
  },
  "FeedItemsCloseBtn": {
    "ID": "FeedItemsCloseBtn",
    "portal_screen_name": "StationDetailScreen",
    "portal_section": "StationDetailWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "FeedItemsPopupCloseBtn",
    "Portal_event_description": "Close button is clicked on feed items popup screen"
  },
  "SignOut": {
    "ID": "SignOut",
    "portal_screen_name": "StationDetailScreen",
    "portal_section": "StationDetailWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "SignOut",
    "Portal_event_description": "SignOut is clicked on stations detail screen"
  },
  "LogOut": {
    "ID": "LogOut",
    "portal_screen_name": "StationDetailScreen",
    "portal_section": "StationDetailWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "LogOut",
    "Portal_event_description": "LogOut is clicked on stations detail screen"
  },
  "Accounts&Settings": {
    "ID": "Accounts&Settings",
    "portal_screen_name": "StationDetailScreen",
    "portal_section": "StationDetailWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Accounts&Settings",
    "Portal_event_description": "Accounts and Settings is clicked on stations detail screen"
  },

  "SoNameBtn": {
    "ID": "SoNameBtn",
    "portal_screen_name": "StationDetailScreen",
    "portal_section": "StationDetailWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "SoName",
    "Portal_event_description": "Me is clicked on stations detail screen"
  },

  "WriteAMessage": {
    "ID": "WriteAMessage",
    "portal_screen_name": "ConnectScreen",
    "portal_section": "ConnectScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "WriteAMessage",
    "Portal_event_description": "Write a message is clicked on connect screen"
  },
  "PreviewBtn": {
    "ID": "PreviewBtn",
    "portal_screen_name": "ConnectScreen - WriteAMessageTab",
    "portal_section": "ConnectScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Preview",
    "Portal_event_description": "Preview button is clicked on connect screen"
  },
  "AttachImage": {
    "ID": "AttachImage",
    "portal_screen_name": "ConnectScreen - WriteAMessageTab",
    "portal_section": "ConnectScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "AttachImage",
    "Portal_event_description": "Attach Image button is clicked on connect screen"
  },
  "AttachImagePopupUnderstandBtn": {
    "ID": "AttachImagePopupUnderstandBtn",
    "portal_screen_name": "ConnectScreen - AttachImagePopup",
    "portal_section": "ConnectScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "IUnderstand",
    "Portal_event_description": "I Understand button is clicked on connect screen - attachimagepopup"
  },
  "AttachImagePopupCloseBtn": {
    "ID": "AttachImagePopupCloseBtn",
    "portal_screen_name": "ConnectScreen - AttachImagePopup",
    "portal_section": "ConnectScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "CloseBtn",
    "Portal_event_description": "Close button is clicked on connect screen - attachimagepopup"
  },

  "DeleteImage": {
    "ID": "DeleteImage",
    "portal_screen_name": "ConnectScreen - DeleteImage",
    "portal_section": "ConnectScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "DeleteImage",
    "Portal_event_description": "Delete Image button is clicked on connect screen"
  },
  "ChooseATemplate": {
    "ID": "ChooseATemplate",
    "portal_screen_name": "ConnectScreen - WriteAMessageTab",
    "portal_section": "ConnectScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "ChooseATemplate",
    "Portal_event_description": "Choose A Template button is clicked on connect screen - WriteAMessage tab"
  },
  "CloseBtnChooseTemplatePopup": {
    "ID": "CloseBtnChooseTemplatePopup",
    "portal_screen_name": "ConnectScreen - ChooseTemplatepopup",
    "portal_section": "ConnectScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "CloseBtn",
    "Portal_event_description": "Close button is clicked on connect screen - ChooseTemplate popup"
  },
  "AddAnotherChild": {
    "ID": "AddAnotherChild",
    "portal_screen_name": "ConnectScreen - AddAnotherChild",
    "portal_section": "ConnectScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "AddAnotherChild",
    "Portal_event_description": "AddAnotherChild button is clicked on connect screen"
  },
  "AddBtnChooseTemplatePopup": {
    "ID": "AddBtnChooseTemplatePopup",
    "portal_screen_name": "ConnectScreen - WriteAMessageTab",
    "portal_section": "ConnectScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Add",
    "Portal_event_description": "Add button is clicked on connect screen"
  },
  "AddReceipt": {
    "ID": "AddReceipt",
    "portal_screen_name": "ConnectScreen - WriteAMessageTab",
    "portal_section": "ConnectScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "AddReceipt",
    "Portal_event_description": "Add Receipt button is clicked on connect screen"
  },
  "SaveReceipt": {
    "ID": "SaveReceipt",
    "portal_screen_name": "ConnectScreen - WriteAMessageTab",
    "portal_section": "ConnectScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "SaveReceipt",
    "Portal_event_description": "Save Receipt button is clicked on connect screen"
  },
  "BibleVerse": {
    "ID": "BibleVerse",
    "portal_screen_name": "ConnectScreen - WriteAMessageTab",
    "portal_section": "ConnectScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "BibleVerse",
    "Portal_event_description": "Bible Verse button is clicked on connect screen"
  },
  "AddBtnBiblePopup": {
    "ID": "AddBtnBiblePopup",
    "portal_screen_name": "ConnectScreen - WriteAMessageTab",
    "portal_section": "ConnectScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Add",
    "Portal_event_description": "Add button is clicked on connect screen - Bible popup"
  },
  "LetterJourney": {
    "ID": "LetterJourney",
    "portal_screen_name": "ConnectScreen",
    "portal_section": "ConnectScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "LetterJourney",
    "Portal_event_description": "Letter Journey tab is clicked on connect screen"
  },
  "FAQs": {
    "ID": "FAQs",
    "portal_screen_name": "ConnectScreen",
    "portal_section": "ConnectScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "FAQs",
    "Portal_event_description": "FAQ tab is clicked on connect screen"
  },
  "WritingTips": {
    "ID": "WritingTips",
    "portal_screen_name": "ConnectScreen",
    "portal_section": "ConnectScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "WritingTips",
    "Portal_event_description": "Writing Tips tab is clicked on connect screen"
  },
  "ConnectFeedItems": {
    "ID": "ConnectFeedItems",
    "portal_screen_name": "ConnectScreen",
    "portal_section": "ConnectScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "FeedItemsArrow",
    "Portal_event_description": "Feed Items is clicked on connect screen"
  },
  "ConnectFeedItemsPopupCloseBtn": {
    "ID": "ConnectFeedItemsPopupCloseBtn",
    "portal_screen_name": "ConnectFeedItemsPopup",
    "portal_section": "ConnectScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "ConnectFeedItemsCloseBtn",
    "Portal_event_description": "Close button is clicked on connect screen - feeditems popup"
  },
  "PDFBtn": {
    "ID": "PDFBtn",
    "portal_screen_name": "ConnectScreen",
    "portal_section": "ConnectScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "PDF",
    "Portal_event_description": "PDF button is clicked on connect screen"
  },
  "GetHelpMessage": {
    "ID": "GetHelpMessage",
    "portal_screen_name": "ConnectFeedItemsPopup",
    "portal_section": "ConnectScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "GetHelpMessage",
    "Portal_event_description": "Get Help Message button is clicked on connect screen - feeditems popup"
  },
  "HowLettersWork": {
    "ID": "HowLettersWork",
    "portal_screen_name": "ConnectFeedItemsPopup",
    "portal_section": "ConnectScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "HowLettersWork",
    "Portal_event_description": "How Letter work button is clicked on connect screen - feeditems popup"
  },
  "SaveDraft": {
    "ID": "SaveDraft",
    "portal_screen_name": "ConnectScreen-WriteAMessageTab",
    "portal_section": "ConnectScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "SaveDraft",
    "Portal_event_description": "Save Draft button is clicked on connect screen"
  },
  "OpenDraft": {
    "ID": "OpenDraft",
    "portal_screen_name": "ConnectScreen-WriteAMessageTab",
    "portal_section": "ConnectScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "OpenDraft",
    "Portal_event_description": "Open Draft button is clicked on connect screen"
  },
  "DiscardDraft": {
    "ID": "DiscardDraft",
    "portal_screen_name": "ConnectScreen-WriteAMessageTab",
    "portal_section": "ConnectScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "DiscardDraft",
    "Portal_event_description": "Discard Draft button is clicked on connect screen"
  },

  "SendGift": {
    "ID": "SendGift",
    "portal_screen_name": "DonateScreen",
    "portal_section": "DonateScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "SendGift",
    "Portal_event_description": "Send Gift button is clicked on donate screen"
  },
  "GiveGift": {
    "ID": "GiveGift",
    "portal_screen_name": "DonateScreen",
    "portal_section": "DonateScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "GiveGift",
    "Portal_event_description": "Give Gift button is clicked on donate screen"
  },
  "YesBtnGiveGiftPopup": {
    "ID": "YesBtnGiveGiftPopup",
    "portal_screen_name": "DonateGiveGiftPopup",
    "portal_section": "DonateScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Yes",
    "Portal_event_description": "Yes button is clicked on donate screen popup"
  },
  "NoBtnGiveGiftPopup": {
    "ID": "NoBtnGiveGiftPopup",
    "portal_screen_name": "DonateGiveGiftPopup",
    "portal_section": "DonateScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "No",
    "Portal_event_description": "No button is clicked on donate screen popup"
  },
  "www.worldvision.fi": {
    "ID": "www.worldvision.fi",
    "portal_screen_name": "DonateGiveGiftPopup",
    "portal_section": "DonateScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "www.worldvision.fi",
    "Portal_event_description": "URL is clicked on donate screen popup"
  },
  "DonationHistory": {
    "ID": "DonationHistory",
    "portal_screen_name": "DonateScreen",
    "portal_section": "DonateScreenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "DontateHistory",
    "Portal_event_description": "Donate History button is clicked on donate screen"
  },
  "NewsFeedItems": {
    "ID": "NewsFeedItems",
    "portal_screen_name": "NewsFeedPopup",
    "portal_section": "NewsFeedWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "NewsFeedItems",
    "Portal_event_description": "Feed Items is clicked on news & stories screen"
  },
  "NewsFeedItemsCloseBtn": {
    "ID": "NewsFeedItemsCloseBtn",
    "portal_screen_name": "NewsFeedPopup",
    "portal_section": "NewsFeedWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "CloseBtn",
    "Portal_event_description": "Close button is clicked on news feed popup"
  },
  "YesBtnNewsFeedPopup": {
    "ID": "YesBtnNewsFeedPopup",
    "portal_screen_name": "NewsFeedPopup",
    "portal_section": "NewsFeedWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Yes",
    "Portal_event_description": "Yes button is clicked on news feed popup"
  },
  "NoBtnNewsFeedPopup": {
    "ID": "NoBtnNewsFeedPopup",
    "portal_screen_name": "NewsFeedPopup",
    "portal_section": "NewsFeedWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "No",
    "Portal_event_description": "No button is clicked on news feed popup"
  },
  "www.worldvision.fi_NewsFeed": {
    "ID": "www.worldvision.fi_NewsFeed",
    "portal_screen_name": "NewsFeedPopup",
    "portal_section": "NewsFeedWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "www.worldvision.fi",
    "Portal_event_description": "URL is clicked on news feed popup"
  },
  "ReadMore": {
    "ID": "ReadMore",
    "portal_screen_name": "NewsFeedScreen",
    "portal_section": "NewsFeedWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "More",
    "Portal_event_description": "Read More button is clicked on news feed"
  },

  "CallUsBtn": {
    "ID": "CallUsBtn",
    "portal_screen_name": "GetHelpScreen",
    "portal_section": "GetHelpWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "CallUs",
    "Portal_event_description": "Call Us button is clicked on Gethelp screen"
  },
  "EnquireOnlineBtn": {
    "ID": "EnquireOnlineBtn",
    "portal_screen_name": "GetHelpScreen",
    "portal_section": "GetHelpWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "EnqireOnline",
    "Portal_event_description": "Enquire Online button is clicked on Gethelp screen"
  },
  "FAQsBtn": {
    "ID": "FAQsBtn",
    "portal_screen_name": "GetHelpScreen",
    "portal_section": "GetHelpWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "FAQs",
    "Portal_event_description": "Faq button is clicked on Gethelp screen"
  },
  "CallUsPopupCloseBtn": {
    "ID": "CallUsPopupCloseBtn",
    "portal_screen_name": "CallUsPopup",
    "portal_section": "GetHelpWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "CallUsCloseBtn",
    "Portal_event_description": "Call Us button is clicked on callus popup"
  },
  "EnquireOnlinePopupCloseBtn": {
    "ID": "EnquireOnlinePopupCloseBtn",
    "portal_screen_name": "EnquireOnlinePopup",
    "portal_section": "GetHelpWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "EnqireOnlineCloseBtn",
    "Portal_event_description": "Close button is clicked on enquire online popup"
  },
  "SubmitBtn": {
    "ID": "SubmitBtn",
    "portal_screen_name": "EnquireOnlinePopup",
    "portal_section": "GetHelpWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Submit",
    "Portal_event_description": "Submit button is clicked on enquire online popup"
  },
  "FaqPopupCloseBtn": {
    "ID": "FaqPopupCloseBtn",
    "portal_screen_name": "FaqPopup",
    "portal_section": "GetHelpWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "FaqCloseBtn",
    "Portal_event_description": "Close button is clicked on FQA popup"
  },
  "FaqPopupYesBtn": {
    "ID": "FaqPopupYesBtn",
    "portal_screen_name": "FaqPopup",
    "portal_section": "GetHelpWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Yes",
    "Portal_event_description": "Yes button is clicked on FQA popup"
  },
  "AddNewChildBtn": {
    "ID": "AddNewChildBtn",
    "portal_screen_name": "GetHelpScreen",
    "portal_section": "GetHelpWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "AddNewChild",
    "Portal_event_description": "Add New Child button is clicked on Gethelp"
  },
  "YesBtnAddNewChildPopup": {
    "ID": "YesBtnAddNewChildPopup",
    "portal_screen_name": "AddNewChildPopup",
    "portal_section": "AddNewChildPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Yes",
    "Portal_event_description": "Yes button is clicked on add new child popup"
  },
  "NoBtnAddNewChildPopup": {
    "ID": "NoBtnAddNewChildPopup",
    "portal_screen_name": "AddNewChildPopup",
    "portal_section": "AddNewChildPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "No",
    "Portal_event_description": "No button is clicked on add new child popup"
  },
  "www.worldvision.fi_AddNewChild": {
    "ID": "www.worldvision.fi_AddNewChild",
    "portal_screen_name": "AddNewChildPopup",
    "portal_section": "AddNewChildPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "www.worldvision.fi",
    "Portal_event_description": "URL is clicked on add new child popup"
  },
  "RecommendedPopupWhatsappBtn": {
    "ID": "RecommendedPopupWhatsappBtn",
    "portal_screen_name": "RecommendedPopup",
    "portal_section": "RecommendedPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Whatsapp",
    "Portal_event_description": "Whatsapp button is clicked on refer child popup"
  },
  "RecommendedPopupSkypeBtn": {
    "ID": "RecommendedPopupSkypeBtn",
    "portal_screen_name": "RecommendedPopup",
    "portal_section": "RecommendedPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Skype",
    "Portal_event_description": "Skype button is clicked on refer child popup"
  },
  "RecommendedPopupEmailBtn": {
    "ID": "RecommendedPopupEmailBtn",
    "portal_screen_name": "RecommendedPopup",
    "portal_section": "RecommendedPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Email",
    "Portal_event_description": "Email button is clicked on refer child popup"
  },
  "RecommendedPopupCopyBtn": {
    "ID": "RecommendedPopupCopyBtn",
    "portal_screen_name": "RecommendedPopup",
    "portal_section": "RecommendedPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Copy",
    "Portal_event_description": "Copy button is clicked on refer child popup"
  },
  "RecommendedPopupCloseBtn": {
    "ID": "RecommendedPopupCloseBtn",
    "portal_screen_name": "RecommendedPopup",
    "portal_section": "RecommendedPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "CloseBtn",
    "Portal_event_description": "Close button is clicked on refer child popup"
  },
  "EmailMyChild": {
    "ID": "EmailMyChild",
    "portal_screen_name": "GetHelpScreen",
    "portal_section": "GetHelpWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "EmailMyChild",
    "Portal_event_description": "Email My Child button is clicked on Gethelp"
  },
  "email@worldvision.org.nz": {
    "ID": "email@worldvision.org.nz",
    "portal_screen_name": "GetHelpScreen",
    "portal_section": "GetHelpWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "email@worldvision.org.nz",
    "Portal_event_description": "URL is clicked on Gethelp popup"
  },
  "ReferAFriend": {
    "ID": "ReferAFriend",
    "portal_screen_name": "GetHelpScreen",
    "portal_section": "GetHelpWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "ReferAFriend",
    "Portal_event_description": "Refer a Friend button is clicked on Gethelp screen"
  },
  "YourAccount": {
    "ID": "YourAccount",
    "portal_screen_name": "AccountSettingScreen",
    "portal_section": "AccountSettingWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "YourAccount",
    "Portal_event_description": "Your Account tab is clicked on accout and settings"
  },
  "SponsorChildren": {
    "ID": "SponsorChildren",
    "portal_screen_name": "AccountSettingScreen",
    "portal_section": "AccountSettingWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "SponsorChildren",
    "Portal_event_description": "Sponsor childer tab is clicked on accout and settings"
  },
  "Donation": {
    "ID": "Donation",
    "portal_screen_name": "AccountSettingScreen",
    "portal_section": "AccountSettingWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Donation",
    "Portal_event_description": "Donation tab is clicked on accout and settings"
  },
  "NotificationPreferences": {
    "ID": "NotificationPreferences",
    "portal_screen_name": "AccountSettingScreen",
    "portal_section": "AccountSettingWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "NotificationPreferences",
    "Portal_event_description": "Notification Preference tab is clicked on accout and settings"
  },
  "PrivacyPolicy_Account": {
    "ID": "PrivacyPolicy_Account",
    "portal_screen_name": "AccountSettingScreen",
    "portal_section": "AccountSettingWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "PrivacyPolicy",
    "Portal_event_description": "Privacy Policy tab is clicked on accout and settings"
  },
  "ProfileImageEditIconBtn": {
    "ID": "ProfileImageEditIconBtn",
    "portal_screen_name": "AccountSettingScreen",
    "portal_section": "AccountSettingWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "ProfileImageEditIcon",
    "Portal_event_description": "Profile image edit icon is clicked on accout and settings"
  },
  "ProfileImagePopupCloseBtn": {
    "ID": "ProfileImagePopupCloseBtn",
    "portal_screen_name": "ProfileImageEditPopup",
    "portal_section": "ProfileImageEditWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "closeBtn",
    "Portal_event_description": "Close button is clicked on profile image edit popup"
  },

  "ChooseFromDeviceBtn": {
    "ID": "ChooseFromDeviceBtn",
    "portal_screen_name": "ProfileImageEditPopup",
    "portal_section": "ProfileImageEditWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Choosefromdevice",
    "Portal_event_description": "Choose from device button is clicked on profile image edit popup"
  },
  "TakeAPhoto": {
    "ID": "TakeAPhoto",
    "portal_screen_name": "ProfileImageEditPopup",
    "portal_section": "ProfileImageEditWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Takeaphoto",
    "Portal_event_description": "Take a Photo button is clicked on profile image edit popup"
  },
  "PhoneEditIconBtn": {
    "ID": "PhoneEditIconBtn",
    "portal_screen_name": "AccountSettingScreen",
    "portal_section": "AccountSettingWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "UpdatePhoneEditIcon",
    "Portal_event_description": "Update Phone Edit Icon is clicked on account setting screen"
  },
  "UpdatePhonePopupYesBtn": {
    "ID": "UpdatePhonePopupYesBtn",
    "portal_screen_name": "UpdatePhonePopup",
    "portal_section": "UpdatePhonePopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Yes",
    "Portal_event_description": "Yes button is clicked on update phone popup"
  },
  "UpdatePhonePopupNotRightNowBtn": {
    "ID": "UpdatePhonePopupNotRightNowBtn",
    "portal_screen_name": "UpdatePhonePopup",
    "portal_section": "UpdatePhonePopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Notrightnow",
    "Portal_event_description": "Not right now button is clicked on update phone popup"
  },
  "HomeAddressEditIconBtn": {
    "ID": "HomeAddressEditIconBtn",
    "portal_screen_name": "AccountSettingScreen",
    "portal_section": "AccountSettingWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "HomeAddress",
    "Portal_event_description": "Home Address edit Icon is clicked on account setting screen"
  },
  "UpdateAddressPopupYesBtn": {
    "ID": "UpdateAddressPopupYesBtn",
    "portal_screen_name": "UpdateAddressPopup",
    "portal_section": "UpdateAddressPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "yes",
    "Portal_event_description": "Yes button is clicked on update address popup"
  },
  "UpdateAddressPopupNotRightNowBtn": {
    "ID": "UpdateAddressPopupNotRightNowBtn",
    "portal_screen_name": "UpdateAddressPopup",
    "portal_section": "UpdateAddressPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Notrightnow",
    "Portal_event_description": "Not right now button is clicked on update address popup"
  },
  "www.worldvision.fi_UpdateAddressPopup": {
    "ID": "www.worldvision.fi_UpdateAddressPopup",
    "portal_screen_name": "UpdateAddressPopup",
    "portal_section": "UpdateAddressPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "www.worldvision.fi",
    "Portal_event_description": "URL is clicked on update address popup"
  },
  "UpdateAddressPopupCloseBtn": {
    "ID": "UpdateAddressPopupCloseBtn",
    "portal_screen_name": "UpdateAddressPopup",
    "portal_section": "UpdateAddressPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "CloseBtn",
    "Portal_event_description": "Close button is clicked on update address popup"
  },
  "EmaiEditIconBtn": {
    "ID": "EmaiEditIconBtn",
    "portal_screen_name": "AccountSettingScreen",
    "portal_section": "AccountSettingWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Email",
    "Portal_event_description": "Email edit icon button is clicked on account setting screen"
  },
  "UpdateEmailPopupYesBtn": {
    "ID": "UpdateEmailPopupYesBtn",
    "portal_screen_name": "UpdateEmailPopup",
    "portal_section": "UpdateEmailPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "yes",
    "Portal_event_description": "Yes button is clicked on update email popup"
  },
  "UpdateEmailPopupNotRightNowBtn": {
    "ID": "UpdateEmailPopupNotRightNowBtn",
    "portal_screen_name": "UpdateEmailPopup",
    "portal_section": "UpdateEmailPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Notrightnow",
    "Portal_event_description": "Not right now button is clicked on update email popup"
  },
  "www.worldvision.fi_UpdateEmailPopup": {
    "ID": "www.worldvision.fi_UpdateEmailPopup",
    "portal_screen_name": "UpdateEmailPopup",
    "portal_section": "UpdateEmailPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "www.worldvision.fi",
    "Portal_event_description": "URL is clicked on update email popup"
  },
  "UpdateEmailPopupCloseBtn": {
    "ID": "UpdateEmailPopupCloseBtn",
    "portal_screen_name": "UpdateEmailPopup",
    "portal_section": "UpdateEmailPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "CloseBtn",
    "Portal_event_description": "Close button is clicked on update email popup"
  },
  "PasswordEditIconBtn": {
    "ID": "PasswordEditIconBtn",
    "portal_screen_name": "AccountSettingScreen",
    "portal_section": "AccountSettingWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Password update",
    "Portal_event_description": "Password Edit icon is clicked on account setting screen"
  },
  "UpdatePasswordPopupYesBtn": {
    "ID": "UpdatePasswordPopupYesBtn",
    "portal_screen_name": "UpdatePasswordPopup",
    "portal_section": "UpdatePasswordPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "yes",
    "Portal_event_description": "Yes button is clicked on update password popup"
  },
  "UpdatePasswordPopupNotRightNowBtn": {
    "ID": "UpdatePasswordPopupNotRightNowBtn",
    "portal_screen_name": "UpdatePasswordPopup",
    "portal_section": "UpdatePasswordPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Notrightnow",
    "Portal_event_description": "Not right now button is clicked on update password popup"
  },
  "wvnz-uat.au.auth0.com": {
    "ID": "wvnz-uat.au.auth0.com",
    "portal_screen_name": "UpdatePasswordPopup",
    "portal_section": "UpdatePasswordPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": " wvnz-uat.au.auth0.com",
    "Portal_event_description": "URL is clicked on update password popup"
  },
  "UpdatePasswordPopupCloseBtn": {
    "ID": "UpdatePasswordPopupCloseBtn",
    "portal_screen_name": "UpdatePasswordPopup",
    "portal_section": "UpdatePasswordPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "CloseBtn",
    "Portal_event_description": "Close button is clicked on update password popup"
  },
  "SelectedChildArrowBtn": {
    "ID": "SelectedChildArrowBtn",
    "portal_screen_name": "SponsorChildrenscreen",
    "portal_section": "SponsorChildrenWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "SelectedChildName",
    "Portal_event_description": "Selected Child is clicked on sponsor children screen"
  },
  "MyPaymentINformationIconBtn": {
    "ID": "MyPaymentINformationIconBtn",
    "portal_screen_name": "DonationScreen",
    "portal_section": "DonationWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "MyPaymentInformation",
    "Portal_event_description": "My Payment Information is clicked on donation screen"
  },
  "MyPaymentInfoPopupYesBtn": {
    "ID": "MyPaymentInfoPopupYesBtn",
    "portal_screen_name": "MyPaymentInfoPopup",
    "portal_section": "MyPaymentInfoPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "yes",
    "Portal_event_description": "Yes button is clicked on my payment info popup"
  },
  "MyPaymentInfoPopupNotRightNowBtn": {
    "ID": "MyPaymentInfoPopupNotRightNowBtn",
    "portal_screen_name": "MyPaymentInfoPopup",
    "portal_section": "MyPaymentInfoPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Notrightnow",
    "Portal_event_description": "Not right now button is clicked on my payment info popup"
  },
  "wvnz-uat.au.auth0.com_MyPayment": {
    "ID": "wvnz-uat.au.auth0.com_MyPayment",
    "portal_screen_name": "MyPaymentInfoPopup",
    "portal_section": "MyPaymentInfoPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": " wvnz-uat.au.auth0.com",
    "Portal_event_description": "URL is clicked on my payment info popup"
  },
  "MyPaymentInfoPopupCloseBtn": {
    "ID": "MyPaymentInfoPopupCloseBtn",
    "portal_screen_name": "MyPaymentInfoPopup",
    "portal_section": "MyPaymentInfoPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "CloseBtn",
    "Portal_event_description": "Close button is clicked on my payment info popup"
  },
  "DownloadTaxStatementIconBtn": {
    "ID": "DownloadTaxStatementIconBtn",
    "portal_screen_name": "DonationScreen",
    "portal_section": "DonationWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "DownloadTaxStatement",
    "Portal_event_description": "Download Tax statement button is clicked on donation screen"
  },
  "TaxReceiptsPopupYesBtn": {
    "ID": "TaxReceiptsPopupYesBtn",
    "portal_screen_name": "TaxReceiptsPopup",
    "portal_section": "TaxReceiptsPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "yes",
    "Portal_event_description": "Yes button is clicked on tax receipts popup"
  },
  "TaxReceiptsPopupNotRightNowBtn": {
    "ID": "TaxReceiptsPopupNotRightNowBtn",
    "portal_screen_name": "TaxReceiptsPopup",
    "portal_section": "TaxReceiptsPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Notrightnow",
    "Portal_event_description": "Not right now button is clicked on tax receipts popup"
  },
  "TaxReceiptsPopupCloseBtn": {
    "ID": "TaxReceiptsPopupCloseBtn",
    "portal_screen_name": "TaxReceiptsPopup",
    "portal_section": "TaxReceiptsPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "CloseBtn",
    "Portal_event_description": "Close button is clicked on tax receipts popup"
  },
  "TaxReceiptsPopupmy.worldvision.org.nz": {
    "ID": "TaxReceiptsPopupmy.worldvision.org.nz",
    "portal_screen_name": "TaxReceiptsPopup",
    "portal_section": "TaxReceiptsPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "my.worldvision.org.nz. ",
    "Portal_event_description": "URL is clicked on tax receipts popup"
  },
  "DataProtection": {
    "ID": "DataProtection",
    "portal_screen_name": "PrivacyPolicyScreen",
    "portal_section": "PrivacyPolicyWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "DataProtection",
    "Portal_event_description": "Data Protection button is clicked on privacy policy tab"
  },
  "DeleteMyAccount": {
    "ID": "DeleteMyAccount",
    "portal_screen_name": "PrivacyPolicyScreen",
    "portal_section": "PrivacyPolicyWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "DeleteMyAccount",
    "Portal_event_description": "Delete My Account button is clicked on privacy policy tab"
  },
  "DeleteMyAccountPopupYesBtn": {
    "ID": "DeleteMyAccountPopupYesBtn",
    "portal_screen_name": "DeleteMyAccountPopup",
    "portal_section": "DeleteMyAccountPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Yes",
    "Portal_event_description": "Yes button is clicked on delete myaccount popup"
  },
  "DeleteMyAccountPopupNoBtn": {
    "ID": "DeleteMyAccountPopupNoBtn",
    "portal_screen_name": "DeleteMyAccountPopup",
    "portal_section": "DeleteMyAccountPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "no",
    "Portal_event_description": "No button is clicked on delete myaccount popup"
  },
  "DeleteMyAccountPopupCloseBtn": {
    "ID": "DeleteMyAccountPopupCloseBtn",
    "portal_screen_name": "DeleteMyAccountPopup",
    "portal_section": "DeleteMyAccountPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "CloseBtn",
    "Portal_event_description": "close button is clicked on delete myaccount popup"
  },
  "CookieSetting": {
    "ID": "CookieSetting",
    "portal_screen_name": "PrivacyPolicyScreen",
    "portal_section": "PrivacyPolicyWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "CookieSetting",
    "Portal_event_description": "Cookie Setting button is clicked on privacy policy screen"
  },
  "CookieSettingPopupSaveSettingBtn": {
    "ID": "CookieSettingPopupSaveSettingBtn",
    "portal_screen_name": "CookieSettingPopup",
    "portal_section": "CookieSettingPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "SaveSetting",
    "Portal_event_description": "Save Setting button is clicked on cookie setting popup"
  },
  "CookieSettingPopupCloseBtn": {
    "ID": "CookieSettingPopupCloseBtn",
    "portal_screen_name": "CookieSettingPopup",
    "portal_section": "CookieSettingPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "CloseBtn",
    "Portal_event_description": "Close button is clicked on cookie setting popup"
  },
  "CookieSettingPopupAnalyticsToggleBtn": {
    "ID": "CookieSettingPopupAnalyticsToggleBtn",
    "portal_screen_name": "CookieSettingPopup",
    "portal_section": "CookieSettingPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "ToggleBtn",
    "Portal_event_description": "Toggle button is clicked on cookie setting popup"
  },
  "ChildMomentsToggleBtn": {
    "ID": "ChildMomentsToggleBtn",
    "portal_screen_name": "NotificationPreferrenceScreen",
    "portal_section": "NotificationPreferrenceWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "ToggleBtn",
    "Portal_event_description": "Toggle button is clicked on notification preferrence screen"
  },
  "LettersAndMessagesToggleBtn": {
    "ID": "LettersAndMessagesToggleBtn",
    "portal_screen_name": "NotificationPreferrenceScreen",
    "portal_section": "NotificationPreferrenceWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "ToggleBtn",
    "Portal_event_description": "Toggle button is clicked on notification preferrence screen"
  },
  "CommunityMomentsToggleBtn": {
    "ID": "CommunityMomentsToggleBtn",
    "portal_screen_name": "NotificationPreferrenceScreen",
    "portal_section": "NotificationPreferrenceWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "ToggleBtn",
    "Portal_event_description": "Toggle button is clicked on notification preferrence screen"
  },
  "LogoutPopupYesBtn": {
    "ID": "LogoutPopupYesBtn",
    "portal_screen_name": "LogoutPopup",
    "portal_section": "LogoutPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "Yes",
    "Portal_event_description": "Yes button is clicked on logout popup"
  },
  "LogoutPopupNoBtn": {
    "ID": "LogoutPopupNoBtn",
    "portal_screen_name": "LogoutPopup",
    "portal_section": "LogoutPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "No",
    "Portal_event_description": "No button is clicked on logout popup"
  },
  "LogoutPopupCloseBtn": {
    "ID": "LogoutPopupCloseBtn",
    "portal_screen_name": "LogoutPopup",
    "portal_section": "LogoutPopupWidget",
    "portal_sub_section": "NA",
    "portal_cta_label_text": "CloseBtn",
    "Portal_event_description": "Close button is clicked on logout popup"
  }
}

export const routePaths = [
  "/getHelp",
  "/chosen-layout/",
  "/chosen-children/",
  "/home",
  "/communityhomeview/",
  "/community/station/",
  "/community/childprofile/",
  "/community/pastSponsoredChild/",
  "/community/childcommunity/",
  "/myaccount",
  "/notification",
  "/sponsorships",
  "/donations",
  "/security",
  "/connect/",
  "/sendAGift/",
  "/donate",
  "/newsandstories",
  "/PageNotFound"
];